/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gc_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free GC content calculator. Paste a DNA or RNA sequence to get the GC%, AT%, base counts and length. FASTA input accepted.`)
};

const es_gc_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita de contenido GC. Pega una secuencia de ADN o ARN para obtener el %GC, %AT, el conteo de bases y la longitud. Acepta entrada en formato FASTA.`)
};

const de_gc_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser GC-Gehalt-Rechner. Fügen Sie eine DNA- oder RNA-Sequenz ein, um GC%, AT%, Basenanzahl und Länge zu erhalten. FASTA-Eingabe wird akzeptiert.`)
};

const nl_gc_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis GC-gehaltecalculator. Plak een DNA- of RNA-sequentie om het GC%, AT%, de basenaantallen en de lengte te krijgen. FASTA-invoer geaccepteerd.`)
};

const fr_gc_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur gratuit de contenu GC. Collez une séquence d'ADN ou d'ARN pour obtenir le %GC, le %AT, le décompte des bases et la longueur. Entrée FASTA acceptée.`)
};

const it_gc_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore gratuito del contenuto GC. Incolla una sequenza di DNA o RNA per ottenere il GC%, l'AT%, il conteggio delle basi e la lunghezza. Accetta input FASTA.`)
};

const pt_br2_gc_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita de conteúdo GC. Cole uma sequência de DNA ou RNA para obter o GC%, AT%, contagem de bases e comprimento. Aceita entrada em FASTA.`)
};

const pt_gc_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita de conteúdo GC. Cole uma sequência de ADN ou ARN para obter o GC%, AT%, contagem de bases e comprimento. Aceita entrada FASTA.`)
};

const ja_gc_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のGC含量計算ツール。DNAまたはRNA配列を貼り付けると、GC%、AT%、塩基数、長さが得られます。FASTA入力可。`)
};

const zh_gc_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费 GC 含量计算器。粘贴 DNA 或 RNA 序列即可获得 GC%、AT%、碱基计数和长度。接受 FASTA 输入。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gc_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gc_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gc_meta_description", locale)
	if (locale === "en") return en_gc_meta_description(inputs)
	if (locale === "es") return es_gc_meta_description(inputs)
	if (locale === "de") return de_gc_meta_description(inputs)
	if (locale === "nl") return nl_gc_meta_description(inputs)
	if (locale === "fr") return fr_gc_meta_description(inputs)
	if (locale === "it") return it_gc_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_gc_meta_description(inputs)
	if (locale === "pt") return pt_gc_meta_description(inputs)
	if (locale === "ja") return ja_gc_meta_description(inputs)
	return zh_gc_meta_description(inputs)
};